import { alpha, Divider, styled } from "@mui/material";

export const IndentDivider = styled(Divider)(({ theme }) => ({
  boxShadow: `0 1px 0 0 #FCFDFF`,
  borderColor: alpha(theme.palette.secondary.main, 0.5),
}));
